@if (apple(); as apple) {
  <era-panel>
    <div class="p-2">
      <ml-mdm-wifi-preset-install></ml-mdm-wifi-preset-install>
      @if (apple.isSupervised && (apple | os: { iOS: '>=8.0'})) {
        <ml-set-wallpaper></ml-set-wallpaper>
      } @if (apple.isSupervised || (apple | os: { macOS: '>=10.10'})) {
        <ml-device-name></ml-device-name>
      } @if (apple | os: { iOS: '>=11.3', macOS: '10.13.4'}) {
        <ml-bluetooth></ml-bluetooth>
      } @if (apple.isSupervised && (apple | os: { macOS: '10.11'})) {
        <ml-host-name></ml-host-name>
      } @if (apple | os: { iOS: '>=5.0'}) {
        <ml-data-roaming></ml-data-roaming>
        <ml-voice-roaming></ml-voice-roaming>
        <ml-personal-hotspot></ml-personal-hotspot>
      }
      <!-- <ml-application-attributes *ngIf="apple | "></ml-application-attributes> -->
      @if (apple | os: { iOS: '>=7.0'}) {
        <ml-mdm-options></ml-mdm-options>
      } @if (apple.maximumResidentUsers && (apple | os: { iOS: '>=9.3.2'})) {
        <ml-pass-code-lock-grace-period></ml-pass-code-lock-grace-period>
      } @if (apple.maximumResidentUsers && apple.awaitingConfiguration && (apple | os: { iOS: '>=9.3'})) {
        <ml-maximum-resident-users></ml-maximum-resident-users>
      } @if (apple.maximumResidentUsers && (apple | os: { iOS: '>=9.3'})) {
        <ml-diagnostic-submission></ml-diagnostic-submission>
      } @if (apple.maximumResidentUsers && (apple | os: { iOS: '>=9.3.2'})) {
        <ml-app-analytics></ml-app-analytics>
      }
    </div>
  </era-panel>
}